var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.274 7.824C1.19 7.824 1.12 7.80067 1.064 7.754C1.01733 7.698 0.994 7.628 0.994 7.544V7.306C0.994 7.21267 1.01267 7.138 1.05 7.082C1.09667 7.01667 1.176 6.94667 1.288 6.872L5.334 4.072L1.288 1.272C1.176 1.19733 1.09667 1.132 1.05 1.076C1.01267 1.01067 0.994 0.931333 0.994 0.838V0.6C0.994 0.516 1.01733 0.450666 1.064 0.404C1.12 0.348 1.19 0.32 1.274 0.32C1.358 0.32 1.484 0.376 1.652 0.487999L5.782 3.344C5.93133 3.44667 6.034 3.54933 6.09 3.652C6.15533 3.74533 6.188 3.85733 6.188 3.988V4.156C6.188 4.28667 6.15533 4.40333 6.09 4.506C6.034 4.59933 5.93133 4.69733 5.782 4.8L1.652 7.656C1.484 7.768 1.358 7.824 1.274 7.824Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.c2aced9400af4fa36db595a8f6fc6eda.svg";
export { ForwardRef as ReactComponent };